import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IPermissionProps } from "../../models/Login";
import { IModal } from "./ClientTransferProgressSetting";
import { Fetch } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";

export interface IClientTransferProgress{
    progress_ID?: number,
    category?: string | null,
    minWet?: number | null,
    maxWet?: number | null,
    bonus?: number | null,
    actions?: string | null,
}

export const EmptyClientTransferProgress = {
    category: "",
    minWet: null,
    maxWet: null,
    bonus: null,
    actions: "",
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const Table = (props: Iprops) => {
    const [tableData,setTableData] = useState({tableData: [], loading: false} as {tableData: IClientTransferProgress[], loading: boolean});
    const dt = useRef<any>(null);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Client Transfer Progress Setting</h5>
        </div>
    );

    const openNew=()=>{
        props.setModal({ open: true, singleData: EmptyClientTransferProgress });
    };
    const openEdit=(rowData: IClientTransferProgress)=>{
        props.setModal({ open: true, singleData: rowData });
    };

    const action=(rowData: IClientTransferProgress)=>{
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={()=>openEdit(rowData)}></Button>
            </div>
        );
    }

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ? <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment> : ''
        );
    };

    const loadTableData = async ()=>{
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("tbl_client_transfer_progress", "GET", null, null, props.toast);
        if(response){
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '3rem' }}/>
                <Column field="category" header="Category"/>
                <Column field="minWet" header="Min Wet" style={{ maxWidth: '8rem' }} />
                <Column field="maxWet" header="Max Wet" style={{ maxWidth: '8rem' }} />
                <Column field="bonus" header="Bonus" style={{ maxWidth: '8rem' }} />
                <Column field="actions" header="Action" />
                {props.permissions.is_Update && <Column field="" header="Edit" body={action} style={{ maxWidth: '4rem' }} />}
            </DataTable>
        </>
    );
}